export default [
  '$scope',
  '$sce',
  'iframeUrl',
  function ($scope, $sce, iframeUrl) {
    $scope.iframeUrl = $sce.trustAsResourceUrl(iframeUrl);
  },
];
